import {
    useMutation,
    useQueryClient
} from "react-query";

import { Assessment } from "../../../API";
import { graphQLAssessmentDAO } from "../GraphQLAssessmentDAO";

export const useUpdateAssessment = () => {
    const queryClient = useQueryClient();

    const updateAssessmentMutation = useMutation({
        mutationFn: async (assessment: Assessment) => {
            return await graphQLAssessmentDAO.update(assessment);
        },
        onMutate: async (assessment: Assessment) => {
            const queryKey = ['assessments', 'property', assessment.propertyId];
            await queryClient.cancelQueries(queryKey);
            const previousAssessments = queryClient.getQueryData(queryKey);
            queryClient.setQueryData(queryKey, (old: Array<Assessment> | undefined) => {
                if (old) {
                    return old.map((a) => a.id === assessment.id ? assessment : a);
                }
                return old || [];
            });
            return { previousAssessments };
        },
        onError: (error, assessment, context) => {
            if (context?.previousAssessments) {
                queryClient.setQueryData(['assessments', 'property', assessment.propertyId], context.previousAssessments);
            }
        },
        onSettled: (data) => {
            const queryKey = ['assessments', 'property', data?.propertyId];
            queryClient.invalidateQueries(queryKey);
        }
    });

    return { updateAssessmentMutation };
};